import { offerMasterService } from "../services";
import { offerMasterConstants } from "../constants";
import { alertActions } from ".";

export const offerMasterActions = {
  getAll,
  createOffer,
  updateOffer,
  inActiveRow,
  onHideShow,
  loadingData,
  onHideShowIsActive,
  exportData
};

function getAll(data) {
  return (dispatch) => {
    dispatch(request());

    offerMasterService.fetchOfferData(data).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: offerMasterConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: offerMasterConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: offerMasterConstants.GETALL_FAILURE, error };
  }
}

function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    offerMasterService.fetchOfferData(obj).then(
      (response) => {
        ;
        dispatch(loadingData(false));
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.OfferId;
            delete v.TotalRows;
            delete v.IsDeleted;
            delete v.CreatedBy;
            delete v.UpdatedBy
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: offerMasterConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: offerMasterConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: offerMasterConstants.GETEXPORT_FAILURE, error };
  }
}

function createOffer(data) {
  return (dispatch) => {
    dispatch(request(data));

    offerMasterService.createOffer(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(onHideShow(false));
            if (response.ResponseData) {
              dispatch(success(response.ResponseData));
            }
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: offerMasterConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: offerMasterConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: offerMasterConstants.CREATE_FAILURE, error };
  }
}

function updateOffer(data) {
  return (dispatch) => {
    dispatch(request(data));

    offerMasterService.updateOffer(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(onHideShow(false));
            dispatch(success(data));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: offerMasterConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: offerMasterConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: offerMasterConstants.UPDATE_FAILURE, error };
  }
}

function inActiveRow(OfferId, isActive) {
  var data = {
    OfferId: OfferId,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    offerMasterService.inActiveRow(OfferId, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: offerMasterConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: offerMasterConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: offerMasterConstants.ISACTIVE_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: offerMasterConstants.DIALOG_REQUEST,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: offerMasterConstants.LOADING_REQUEST,
    isbool,
  };
}

function onHideShowIsActive(isbool) {
  return {
    type: offerMasterConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}
